import React, { useState } from "react";
import "./Tabs.css"; // Include your CSS for styling
import { SectionBorder } from "molecules/SectionBorder";

const Tabs = () => {
  const [activeTab, setActiveTab] = useState("summary");

  return (
    <div className="tabs-container  mb-2">
      {/* Tab Headers */}
      <div className="tabs-header width75 pl-0 ">
        <button
          className={activeTab === "summary" ? "tab active transcriptBorderBottom mr-5 " : "tab pl-0 pb-2 "}
          onClick={() => setActiveTab("summary")}
        >
          Summary
        </button>
        <button
          className={activeTab === "transcript" ? "tab active transcriptBorderBottom " : "tab px-0 pb-2 "}
          onClick={() => setActiveTab("transcript")}
        >
          Transcript
        </button>
      </div>

      {/* Tab Content */}
      <div className="tabs-content width75 pl-0">
        {activeTab === "summary" && (
          <div className="tab-content  pl-0 font17">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Repellendus quidem harum delectus. Ullam magnam quidem officiis,
              corporis quisquam quae quas cumque, est obcaecati saepe ipsam qui
              commodi voluptatum eius impedit. Inventore saepe consequuntur
              similique dicta nam molestias atque eos possimus eum rem corrupti,
              delectus perferendis repellendus qui quos eius porro. Sit,
              excepturi quos! Nostrum, incidunt? Impedit beatae dolores nostrum
              corporis? Vel adipisci animi fugiat ab temporibus blanditiis nam
              ex, pariatur a repellendus beatae quo praesentium eveniet
              laboriosam quam natus facilis maiores inventore? Possimus hic nemo
              necessitatibus officiis. Excepturi, voluptatum perspiciatis!
              Provident repellat repudiandae, labore recusandae harum modi ex
              iusto cum distinctio explicabo laudantium totam reprehenderit?
              Error cum est rerum. Mollitia, eius hic aspernatur facere harum
              consequatur libero enim ad esse? Dolore quod deleniti quia, eaque
              ipsum quasi quaerat qui, veniam blanditiis tempore impedit
              mollitia harum vero possimus perspiciatis doloremque, saepe
              aliquam alias pariatur! Autem, nam iusto reiciendis ullam quaerat
              reprehenderit? Nisi quas, perspiciatis placeat veritatis
              perferendis cumque modi odit molestias exercitationem! Asperiores
              minima quasi, nam sequi quaerat velit. Sint fugit ducimus illo
              quisquam, maiores suscipit non debitis magnam harum! Quas. Ipsum
              est dolorum aperiam possimus delectus, placeat accusamus libero
              modi, id voluptatem consequatur mollitia veniam sequi. Veritatis a
              quibusdam commodi aliquid nulla nemo, ipsam, quos magnam soluta
              nostrum quidem natus. Reiciendis dolores vero eos tempora saepe
              veniam atque nesciunt voluptates cum eius? Debitis, excepturi,
              sequi at sint cumque repellendus recusandae voluptatem autem culpa
              nobis dolore nihil, nesciunt magni rerum eligendi! Accusantium
              suscipit assumenda sed voluptas id, qui corporis aperiam minima
              quibusdam unde commodi natus eius voluptatum? Quo excepturi odit
              molestiae ipsa? Libero maiores explicabo rem, qui voluptas ab amet
              quidem. Enim, maxime quaerat! Maxime delectus tempore ex eaque
              laboriosam ut praesentium id ullam. Qui perferendis eos iste nemo
              quisquam, sapiente laudantium perspiciatis. Optio cum
              exercitationem numquam minima eos et sapiente! Illo dolorum fuga
              voluptas blanditiis eaque tempore deleniti esse quaerat, molestiae
              suscipit labore accusantium optio quo rem nulla officia! At,
              dolor! Consectetur molestias nobis, repellendus aut ipsum et illum
              iure. Ullam perspiciatis repudiandae laudantium aperiam aut
              temporibus minus iusto, veniam nulla commodi deleniti esse
              explicabo sit ex praesentium et, facilis quaerat? Molestias
              repellat soluta laboriosam, iure quisquam tenetur vero aliquid!
              Molestiae velit tempore, veritatis officiis vero nisi quisquam
              omnis natus laboriosam? Vitae aut vel, dolores eos officiis labore
              totam consequuntur, vero similique consequatur architecto! Iure
              quaerat nisi consequuntur quisquam voluptatem! Quo expedita
              repudiandae quis quisquam assumenda commodi tempore eveniet, fugit
              cupiditate fugiat illum asperiores earum, fuga quae consequuntur!
              Sit praesentium quos debitis consequatur veritatis ullam esse
              asperiores odio eaque optio! Nesciunt est quidem, perspiciatis
              quaerat inventore molestias accusantium, consectetur odio non
              tempora doloribus cupiditate? Exercitationem eaque accusamus ipsum
              aliquam porro aut nemo nostrum illo maiores, neque nulla unde iure
              similique? Veniam necessitatibus veritatis unde molestias tempore?
              Iure, illum necessitatibus? Iusto a, maiores quis accusantium
              blanditiis inventore eius sequi ut hic minus placeat unde
              reiciendis doloremque est quibusdam ullam corrupti similique! Amet
              nam ipsum velit beatae, temporibus non eius rem quisquam
              repellendus id hic quasi excepturi ab? Fugiat, porro iusto iure,
              dignissimos totam veniam tempora explicabo neque corporis autem
              voluptatum illum! Dignissimos aspernatur placeat odit consequuntur
              voluptas aliquam deserunt corporis, reiciendis nulla reprehenderit
              quos quas. Sapiente illo quia mollitia quisquam dignissimos
              distinctio atque, doloribus corporis ut nam cum, quasi ipsa
              voluptate? Quam exercitationem reiciendis eaque animi, commodi
              veritatis harum sed. Iste rerum molestiae harum eligendi,
              doloremque distinctio esse quidem earum autem eos qui totam, atque
              temporibus eius vel corporis quos alias. Rerum est ipsa voluptas
              similique nihil magnam sit eos accusantium qui voluptate
              reprehenderit fugiat praesentium modi, sequi, a veritatis?
              Deleniti tenetur veritatis labore at atque quod. Saepe autem
              libero sunt.
            </p>
          </div>
        )}
        {activeTab === "transcript" && (
          <div className="tab-content font17 ">
          <p className="transcriptPara">Gaurav Pant, Partner, Hybrid Value, Asia Pacific: Global Schools is a private international education group headquartered in Singapore, which is now present in about 13 countries and 40+ campuses.</p>

          <p className="transcriptPara">Atul Temurnikar, Cofounder & Executive Chairman, Global Schools Foundation: We work on building a holistic citizen by incorporating programs which are holistic and wide in nature. We started in 2002 with one school, 48 students, just at the back of the Presidential Palace and that's how the journey began.</p>
          <p className="transcriptPara">Gaurav Pant, Partner, Hybrid Value, Asia Pacific: Global Schools is a private international education group headquartered in Singapore, which is now present in about 13 countries and 40+ campuses.</p>

          <p className="transcriptPara">Atul Temurnikar, Cofounder & Executive Chairman, Global Schools Foundation: We work on building a holistic citizen by incorporating programs which are holistic and wide in nature. We started in 2002 with one school, 48 students, just at the back of the Presidential Palace and that's how the journey began.</p>
          <p className="transcriptPara">Gaurav Pant, Partner, Hybrid Value, Asia Pacific: Global Schools is a private international education group headquartered in Singapore, which is now present in about 13 countries and 40+ campuses.</p>

          <p className="transcriptPara">Atul Temurnikar, Cofounder & Executive Chairman, Global Schools Foundation: We work on building a holistic citizen by incorporating programs which are holistic and wide in nature. We started in 2002 with one school, 48 students, just at the back of the Presidential Palace and that's how the journey began.</p>
        
          </div>
        )}

        <SectionBorder/>

        <section className="section-padding pl-0">
          <h4>
            Tags
          </h4>
          <div className="" style={{width:'max-content'}}>
          <div className="rounded-pill my-2  border-1  px-4 py-1 w-fit font17 fontAva" style={{borderColor:'#000'}}>
            Building and financing Bussiness
          </div>
          <div className="d-flex">
          <div className="rounded-pill mr-1  border-1 px-4 py-1 w-fit font17 fontAva" style={{borderColor:'#000'}}>
            Video  
          </div>
          <div className="rounded-pill mr-1  border-1 px-4 py-1 w-fit font17 fontAva" style={{borderColor:'#000'}}>
            Equality 
          </div>
          <div className="rounded-pill mr-1  border-1 px-4 py-1 w-fit font17 fontAva" style={{borderColor:'#000'}}>
            CaseStydy 
          </div>
          </div>
          </div>
          </section>
      </div>
    </div>
  );
};

export default Tabs;
